<template>
  <div class="ui fluid action input password">
    <div>
      <Modal :id="'genpass-modal-' + _uid" class="genpass modal" size="small" title="生成密码" @ok="use_generated">
        <h1 class="text-2xl text-center my-4 font-bold break-all">
          {{ generated_password }}
        </h1>
        <div class="ui form">
          <div class="field">
            <div class="ui toggle checkbox">
              <label>包含数字</label>
              <input name="include-nums" id="include-nums" type="checkbox" v-model="use_number" tabindex="0" class="hidden">
            </div>
          </div>
          <div class="field">
            <div class="ui toggle checkbox">
              <label>包含大写字母</label>
              <input name="include-upper" id="include-upper" type="checkbox" v-model="use_upper" tabindex="0" class="hidden">
            </div>
          </div>
          <div class="field">
            <div class="ui toggle checkbox">
              <label>包含特殊符号</label>
              <input id="include-special" name="include-special" type="checkbox" v-model="use_special" tabindex="0" class="hidden">
            </div>
          </div>
          <div class="field inline">
            <div class="ui input">
              <input id="password-length" name="password-length" type="number" v-model="pass_len" min="5" max="64"/>
            </div>
            个字符
          </div>
          <div class="my-4">
            <input id="password-length-range" name="password-length-range" type="range" v-model="pass_len" class="w-full" min="5" max="64">
          </div>
          <div class="my-4">
            <button class="ui teal button my-4" @click="copy_to_clipboard($event, generated_password, '密码')">
              <i class="copy icon"></i>
              复制
            </button>
            <button class="ui button my-4" @click="refresh">
              <i class="redo alternate icon"></i>
              刷新
            </button>
          </div>
        </div>
      </Modal>
    </div>
    <input maxlength="255" :name="'password-' + _uid" v-model="password" @input="$emit('input', password)" :type="input_type" :id="id"/>
    <div class="ui button" data-content="显示" v-if="input_type=='password'" @click="input_type='text'">
      <i class="eye icon"></i>
    </div>
    <div class="ui button" v-else data-content="隐藏" @click="input_type='password'">
      <i class="eye slash icon"></i>
    </div>
    <div class="ui button" data-content="快速生成" @click="genpass_quick">
      <i class="ui seedling icon"></i>
    </div>
    <div class="ui button" data-content="生成" @click="genpass_show">
      <i class="ellipsis horizontal icon"></i>
    </div>
    <div class="ui button" data-content="复制" @click="copy_to_clipboard($event, value, '密码')">
      <i class="copy icon"></i>
    </div>
  </div>
</template>

<script>
import Modal from './modal';

export default {
  name: 'PasswordInput',
  props: ['value', 'id'],
  components: {
    Modal,
  },
  data: function () {
    return {
      input_type: 'password',
      pass_len: 10,
      use_upper: true,
      use_number: true,
      use_special: false,
      salt: 0,
      password: this.value,
    };
  },
  computed: {
    generated_password() {
      var passlen = Math.floor(this.pass_len) + this.salt - this.salt;
      return this.client.generate_password(passlen, this.use_upper, this.use_number, this.use_special);
    },
  },
  methods: {
    genpass_quick() {
      this.password = this.client.generate_password(10, true, true);
      this.$emit('input', this.password);
    },
    genpass_show() {
      this.refresh();
      this.show_modal('genpass-modal-' + this._uid, true);
    },
    refresh() {
      this.salt++;
    },
    use_generated() {
      this.password = this.generated_password;
      this.$emit('input', this.generated_password);
    },
    copy_to_clipboard(e, text, item_name='') {
      this.$gtag.event('copy-new-password', {
        event_category: 'user-action',
        event_label: 'password-manager',
      });
      var dummy = document.createElement("textarea");
      e.target.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      e.target.removeChild(dummy);
      this.show_success(item_name + "已复制到剪贴板");
    },
    reset() {
      this.reset_data();
      this.password = this.value;
    },
  },
  mounted() {
    this.$(".ui.checkbox").checkbox();
    this.$(".password.input .ui.button").popup();
  },
}
</script>

<style scoped>

.password.input .ui.button {
  padding-left: 0.8rem !important;
  padding-right: 0.8rem !important;
}
.password.input .ui.button i {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
